import {
  useDynamicContext,
  useSwitchWallet,
  Wallet,
} from '@dynamic-labs/sdk-react-core';
import { useQuery } from '@tanstack/react-query';
import { atom, useAtom } from 'jotai';

import { useClaim } from './use-claim';

const buttonClickedAtom = atom(false);
const walletAddressAtom = atom<string | null>(null);

export const useSwitchWalletCore = () => {
  const [buttonClicked, setButtonClicked] = useAtom(buttonClickedAtom);
  const [walletAddress, setWalletAddress] = useAtom(walletAddressAtom);

  const { handleDecompress } = useClaim();
  const { primaryWallet } = useDynamicContext();
  const switchWallet = useSwitchWallet();

  const handleSwitchWallet = (wallet: Wallet) => {
    if (primaryWallet?.address !== wallet.address) {
      setButtonClicked(true);
      setWalletAddress(wallet.address);
      switchWallet(wallet.id);
    } else {
      handleDecompress(wallet.address);
      setButtonClicked(false);
    }
  };

  useQuery({
    queryKey: [primaryWallet?.address, buttonClicked],
    queryFn: async () => {
      if (primaryWallet?.address === walletAddress && buttonClicked) {
        handleDecompress(primaryWallet.address);
        setButtonClicked(false);
        return true;
      }
      return false;
    },
  });

  return {
    handleSwitchWallet,
  };
};
